module.exports = __webpack_public_path__ + "img/cocktail.3701c75f.webp";